import React, { useEffect } from "react";
import {
  SubTitle,
  ContentContainer,
  Title,
  TitleContainer,
  Input,
  Button,
  ChipInPrice,
  ChipInText,
  ChipInRow,
} from "./ChipInModal.styles";

import { useTranslation } from "react-i18next";
import ModalDownload from "../Modal/ModalDownload";
import { getCurrencySymbol } from "../../utils/constants";

const ChipInModal = ({
  modalRef,
  value,
  setValue,
  maxAmount,
  onChipIn,
  remainingPrice,
  item,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (value > +remainingPrice) {
      setValue(remainingPrice.toFixed(2));
    } else if (+remainingPrice < 50) {
      setValue(remainingPrice.toFixed(2));
    }
  }, [remainingPrice, setValue, value]);

  return (
    <ModalDownload
      width={345}
      height={"fit-content"}
      ref={modalRef}
      onClose={() => {
        modalRef.current.hide();
      }}
    >
      <ContentContainer>
        <TitleContainer>
          <Title>{t("amount")}</Title>
          <SubTitle>{t("enter-an-amount-to-chip-in")}</SubTitle>
        </TitleContainer>
        <Input
          type="number"
          value={value}
          placeholder={t("amount")}
          max={+maxAmount}
          onChange={(e) => setValue(e.target.value)}
          min={50}
        />
        <ChipInRow>
          <ChipInText>{t("remaining")}:</ChipInText>
          <ChipInPrice $red>
            {remainingPrice.toFixed(2)}{" "}
            {getCurrencySymbol(item?.currency ?? "sar")}
          </ChipInPrice>
        </ChipInRow>
        <Button
          onClick={() => {
            if (remainingPrice >= 50 && +value < 50) {
              setValue(50);
            }
            onChipIn();
          }}
        >
          {t("chip-in")}
        </Button>
      </ContentContainer>
    </ModalDownload>
  );
};

export default ChipInModal;
